import {
  INSTRUMENT_LIST_ENDPOINT,
  useGetEndpoint,
} from '@edata-portal/icat-plus-api';

export function LoadInstrumentUrl({ instrument }: { instrument: string }) {
  const icatPlusInstruments = useGetEndpoint({
    endpoint: INSTRUMENT_LIST_ENDPOINT,
  });

  if (!icatPlusInstruments) {
    return instrument;
  }

  const instrumentObj = icatPlusInstruments.find((i) => i.name === instrument);

  if (!instrumentObj?.url) {
    return instrument;
  }

  return (
    <a href={instrumentObj.url} target="_blank" rel="noopener noreferrer">
      {instrument}
    </a>
  );
}
